export type GlobalChatCommand = {
	conversationId: string
	prefillText?: string
}

export function openGlobalChat(command: GlobalChatCommand) {
	window.dispatchEvent(new CustomEvent('jobibot:open', { detail: command }))
}
